export const ACS_SCHEDULE_SECTION_EVENT =
	'canvas-agent:acs-schedule:section';
export const ACS_SCHEDULE_CREATE_MODAL_EVENT =
	'canvas-agent:acs-schedule:create-modal';
export const ACS_SCHEDULE_FILTER_EVENT =
	'canvas-agent:acs-schedule:filter';
export const ACS_SCHEDULE_FOCUS_EVENT =
	'canvas-agent:acs-schedule:focus';
export const ACS_SCHEDULE_EDIT_MODAL_EVENT =
	'canvas-agent:acs-schedule:edit-modal';
export const ACS_SCHEDULE_DELETE_MODAL_EVENT =
	'canvas-agent:acs-schedule:delete-modal';
